import BG from '../asset/company_logo_header.png'
const ServicesPage = props => {
    return (
        <img src={BG} alt="logo" />
    )

}

export default ServicesPage
